import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import { IAM_PATH, IAM_SERVER_SERVICE_USER } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import { containsXss } from "../../../utils/security/XssFilter";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import Switch from "@mui/material/Switch";
import Loading from "../../../utils/loading/Loading";
import { SensorListContainer } from "./SensorListContainer";

import { ADMINROLE } from "../ServiceUser";
import { ADMINROLE_LABEL } from "./ServiceUserRegisterModal";
import { isEmailSimple } from "../../../utils/modal/ValidEmail";

/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const ServiceUserDetailModal = ({ id, update, idToNameMap }) => {

    const { closeModal } = useContext(ModalContext);

    const [loading, setLoading] = useState(true);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    const [checked, setChecked] = useState(false); // 비밀번호 변경 옵션(Switch)

    const [formData, setFormData] = useState({
        id: id,
        userId: '',
        password: '',
        passwordConfirm: '',
        userName: '',
        email: '',
        phone: '',
        groupId: '0',
        role: '',
        status: ''
    });

    useEffect(() => {
        // id로 사용자 정보 조회
        const url = IAM_PATH + IAM_SERVER_SERVICE_USER + "/get/" + id;
        axios.get(url)
            .then((res) => {
                setFormData({
                    id: id,
                    userId: res.data.data.userId,
                    password: res.data.data.password,
                    passwordConfirm: '',
                    userName: res.data.data.userName,
                    email: res.data.data.email,
                    phone: res.data.data.phone,
                    groupId: res.data.data.groupId,
                    role: res.data.data.role,
                    status: res.data.data.status
                });
            })
            .catch((e) => {
                console.error(e);
                // showDialog(DialogEnum.DEFAULT, "실패", e.respnose.data.resultMessage); todo
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setLoading(false);
            })



    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleDeleteAdmin = (item) => {
        const confirmText = "계정 관리자를 삭제하시겠습니까?";

        showDialog(DialogEnum.CONFIRM, "상태 변경 확인", confirmText, () => {
            const url = IAM_PATH + IAM_SERVER_SERVICE_USER + '/delete/' + item.id;

            axios.post(url)
                .then((res) => {
                    if (res.data.code == 200) {
                        showDialog(DialogEnum.SUCCESS, "성공", "관리자 삭제 성공.", closeModal);
                        update();
                    } else {
                        showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                    }
                })
                .catch((e) => {
                    console.error("서비스 탈퇴 실패:", e);
                    showDialog(DialogEnum.DEFAULT, "오류", "관리자 삭제중 오류가 발생했습니다.", e.response.data.resultMessage);
                });
        });
    };


    const handlePasswordReset = (item) => {
        const params = Object.assign({}, formData);
        params.id = id

        const confirmText = "비밀번호를 초기화 하시겠습니까?";

        showDialog(DialogEnum.CONFIRM, "비밀번호 초기화", confirmText, () => {
            const url = IAM_PATH + IAM_SERVER_SERVICE_USER + "/reset";

            axios.post(url, params)
                .then((res) => {
                    if (res.data.code == 200) {
                        showDialog(DialogEnum.SUCCESS, "완료", '비밀번호가 초기화 되었습니다. 비밀번호 : ' + res.data.message, closeModal);
                        update();
                    } else {
                        showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                    }
                })
                .catch((e) => {
                    console.error("서비스 탈퇴 실패:", e);
                    showDialog(DialogEnum.DEFAULT, "오류", "비밀번호 초기화 중 오류가 발생했습니다.");
                });
        });
    };

    const handleUpdate = (item) => {
        let isValid = true;

        for (let key in formData) {
            if (key === 'email') {
                if (!isEmailSimple(formData[key])) {
                    showDialog(DialogEnum.DEFAULT, "경고", "올바른 이메일을 입력해 주세요.");
                    isValid = false;
                    break;
                }
            }

            if (formData[key] === '') {
                if (!(key === 'passwordConfirm')) {
                    setIsNull(true);
                    isValid = false;
                    break;
                } else if (containsXss(formData[key])) {
                    setFormData((prevState) => ({
                        ...prevState,
                        [key]: ''
                    }))
                    setIsNull(true);
                    showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                    isValid = false;
                    break;
                }
            }
        }

        if (!isValid) return;
        setIsNull(false);

        const params = Object.assign({}, formData);
        params.id = id

        // 비밀번호 확인
        if (formData.passwordConfirm && formData.passwordConfirm !== formData.password) {
            showDialog(DialogEnum.DEFAULT, "경고", "비밀번호가 일치하지 않습니다.");
            return;
        }

        if (!formData.passwordConfirm) {
            delete params.passwordConfirm;
        }

        const url = `${IAM_PATH}${IAM_SERVER_SERVICE_USER}/update`;
        axios.post(url, params)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }


    const handleCancle = () => {
        closeModal();
    }

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>아이디</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"id"}
                                value={formData.userId}
                                readOnly={true}
                                style={{ backgroundColor: '#00000010', cursor: "default" }}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비밀번호</p>
                            <input className={styles.layer__listInput}
                                type={"password"}
                                name={"password"}
                                value={formData.password}
                                readOnly={true}
                                onChange={handleChange} />
                            {/* <button
                                className={`commonStatusBtn ${styles.layer__statusBtn__gray}`}
                                style={{ marginLeft: '10px', height: '40px', fontSize: '12px' }}
                                onClick={() => setChecked(prev => !prev)}
                            >
                                {checked ? '변경 취소' : '비밀번호 변경'}
                            </button> */}
                            {/* <div style={{ display: 'flex', alignItems: 'center', width:'10%' }}>
                                <Switch
                                checked={checked}
                                onChange={(e) => setChecked(e.target.checked)}
                                color="primary"
                                size="small"
                                />
                                <span style={{ fontSize: '12px' }}>변경</span>
                            </div> */}
                            <button className={`commonStatusBtn ${styles.layer__cancleBtn}`}
                                style={{
                                    width: '10%',
                                    height: '40px',
                                    fontSize: '12px',
                                    overflow: 'visible'
                                }}
                                onClick={() => handlePasswordReset(formData)}>비밀번호 초기화</button>
                        </li>
                        {/* {checked && (
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비밀번호 확인</p>
                            <input className={styles.layer__listInput}
                                   type={"password"}
                                   name={"passwordConfirm"}
                                   value={formData.passwordConfirm ?? ''}
                                   readOnly={false}
                                   onChange={handleChange}/>
                        </li>
                        )} */}
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>이름</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"userName"}
                                value={formData.userName}
                                readOnly={false}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>전화번호</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"phone"}
                                value={formData.phone}
                                readOnly={false}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>이메일</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"email"}
                                value={formData.email}
                                readOnly={false}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>권한</p>
                            <select
                                className={styles.layer__listInput}
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                            >
                                <option value={""}>{":: 권한을 선택하세요 ::"}</option>
                                {/* {Object.entries(ADMINROLE).map(([id, name]) => (
                                    <option key={id} value={id}>
                                        {name}
                                    </option>
                                ))} */}
                                {Object.entries(ADMINROLE).map(([id]) => (
                                    <option key={id} value={id}>
                                        {ADMINROLE_LABEL[id]}
                                    </option>
                                ))}
                            </select>
                        </li>
                        {formData.role !== ADMINROLE.SYS_ADMIN && (
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>그룹명</p>
                                <input className={styles.layer__listInput}
                                    type={"text"}
                                    name="groupId"
                                    value={idToNameMap[formData.groupId]}
                                    readOnly={true}
                                    style={{ backgroundColor: '#00000010', cursor: "default" }}
                                />
                                {/* <select
                                    className={styles.layer__listInput}
                                    name="groupId"
                                    value={formData.groupId}
                                    onChange={handleChange}
                                >
                                    <option value={"0"}>{":: 관리할 그룹을 선택하세요 ::"}</option>
                                    {Object.entries(idToNameMap).map(([id, name]) => (
                                        <option key={id} value={id}>
                                            {name}
                                        </option>
                                    ))}
                                </select> */}
                            </li>
                        )}
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>상태</p>
                            <select
                                className={styles.layer__listInput}
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={"false"}>{"비활성화"}</option>
                                <option value={"true"}>{"활성화"}</option>
                            </select>
                        </li>
                    </ul>
                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    {/* <div className={styles.layer__sensorBox}>
                        <p className={styles.layer__sensorTit}>서비스 정보</p>
                        <SensorListContainer id={id} detailList={detailList} update={update}/>
                    </div> */}

                    <div className={styles.layer__sensorBtnBox}>
                        {/* <button className={styles.layer__cancleBtn} onClick={handleCancle}>취소</button>
                        <button className={styles.layer__modifyBtn} onClick={handleModify}>수정</button> */}
                        {sessionStorage.getItem('id') != id && (
                            <button className={`commonStatusBtn ${styles.layer__cancleBtn}`} onClick={() => handleDeleteAdmin(formData)}>삭제</button>
                        )}
                        {/* <button className={`commonStatusBtn ${formData.status ? styles.layer__statusBtn__gray : styles.layer__statusBtn__green}`}
                            onClick={() => handleToggleStatus(formData)}
                        >{formData.status ? '비활성화' : '활성화'}
                        </button> */}
                        <button className={styles.layer__statusBtn__green} onClick={() => handleUpdate(formData)}>수정</button>
                    </div>
                </div>
            }
        </div>
    );
}